(function () {
  /* ----- Recovery: clear any stuck zoom state from previous crash-prone version ----- */
  var STATE_VERSION = '3';
  try {
    if (localStorage.getItem('hrStateVersion') !== STATE_VERSION) {
      localStorage.removeItem('hrZoomed');
      localStorage.setItem('hrStateVersion', STATE_VERSION);
    }
  } catch (e) {}

  /* ----- Touch / narrow-viewport detection -----
     View Transitions API captures GPU snapshots of every element with
     `view-transition-name`; on iOS Safari with 9-18 product tiles + images this
     hits memory limits and crashes ("a problem repeatedly occurred").
     So we skip the transition path entirely on touch / mobile. ----- */
  var IS_TOUCH = ('ontouchstart' in window && (navigator.maxTouchPoints || 0) > 0);
  var IS_NARROW = (window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  var SKIP_VT = IS_TOUCH || IS_NARROW || !document.startViewTransition;

  function smoothToggle(fn) {
    if (SKIP_VT) {
      fn();
      return;
    }
    try {
      document.startViewTransition(fn);
    } catch (e) {
      fn();
    }
  }

  /* Throttle: prevent stacked transitions if user clicks fast */
  var transitioning = false;
  function withThrottle(fn) {
    if (transitioning) return;
    transitioning = true;
    setTimeout(function () { transitioning = false; }, 450);
    smoothToggle(fn);
  }

  function injectOurStory() {
    /* Desktop inline menu */
    var desktopMenus = document.querySelectorAll('.header-menu .menu-list, .header-menu ul');
    desktopMenus.forEach(function (menu) {
      if (menu.querySelector('[data-hr-our-story]')) return;
      var li = document.createElement('li');
      li.setAttribute('data-hr-our-story', '');
      li.className = 'menu-list__list-item';
      var a = document.createElement('a');
      a.href = '#our-story';
      a.className = 'menu-list__link';
      var span = document.createElement('span');
      span.className = 'menu-list__link-title';
      span.textContent = 'Our Story';
      a.appendChild(span);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        openStoryModal();
      });
      li.appendChild(a);
      menu.appendChild(li);
    });

    /* Mobile drawer menu */
    var drawerMenus = document.querySelectorAll('.menu-drawer__menu');
    drawerMenus.forEach(function (menu) {
      if (menu.querySelector('[data-hr-our-story]')) return;
      var li = document.createElement('li');
      li.setAttribute('data-hr-our-story', '');
      li.className = 'menu-drawer__list-item--flat';
      var a = document.createElement('a');
      a.href = '#our-story';
      a.className = 'menu-drawer__menu-item menu-drawer__menu-item--mainlist menu-drawer__animated-element focus-inset';
      var span = document.createElement('span');
      span.className = 'menu-drawer__menu-item-text wrap-text';
      span.textContent = 'Our Story';
      a.appendChild(span);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        openStoryModal();
      });
      li.appendChild(a);
      menu.appendChild(li);
    });
  }

  function injectStoryModal() {
    if (document.querySelector('.hr-story-modal')) return;
    var imgUrl = window.HR_STORY_IMG || '';
    if (!imgUrl) return;
    var modal = document.createElement('div');
    modal.className = 'hr-story-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-label', 'Our Story');

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'hr-story-modal__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', closeStoryModal);

    var inner = document.createElement('div');
    inner.className = 'hr-story-modal__inner';
    var img = document.createElement('img');
    img.className = 'hr-story-modal__img';
    img.alt = 'Our Story';
    img.loading = 'lazy';
    img.dataset.src = imgUrl;
    inner.appendChild(img);

    modal.appendChild(closeBtn);
    modal.appendChild(inner);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeStoryModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeStoryModal();
    });
    document.body.appendChild(modal);
  }

  function openStoryModal() {
    var modal = document.querySelector('.hr-story-modal');
    if (!modal) { injectStoryModal(); modal = document.querySelector('.hr-story-modal'); }
    if (!modal) return;
    var img = modal.querySelector('.hr-story-modal__img');
    if (img && !img.src && img.dataset.src) img.src = img.dataset.src;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hr-story-open');
  }

  function closeStoryModal() {
    var modal = document.querySelector('.hr-story-modal');
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hr-story-open');
  }

  function renameHomeRemoveCatalog() {
    var titles = document.querySelectorAll(
      '.menu-list__link-title, .menu-drawer__menu-item-text'
    );
    titles.forEach(function (el) {
      if (el.dataset.hrRenamed) return;
      var text = (el.textContent || '').trim();
      var lower = text.toLowerCase();
      if (lower === 'home') {
        el.textContent = 'Shop';
        el.dataset.hrRenamed = '1';
      } else if (lower === 'catalog') {
        var li = el.closest('li') || el.parentElement;
        if (li) {
          li.style.display = 'none';
          el.dataset.hrRenamed = '1';
        }
      }
    });
  }

  function injectZoomToggle() {
    if (document.querySelector('.hr-zoom-toggle')) return;
    var isProductPage = /\/products\//.test(window.location.pathname);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hr-zoom-toggle';

    if (isProductPage) {
      /* On product pages, the corner button is a back-to-shop arrow */
      btn.setAttribute('aria-label', 'Back to shop');
      btn.textContent = '‹';
      btn.classList.add('hr-zoom-toggle--back');
      btn.addEventListener('click', function () {
        if (document.referrer && document.referrer.indexOf(window.location.origin) === 0) {
          window.history.back();
        } else {
          window.location.href = '/';
        }
      });
      document.body.appendChild(btn);
      return;
    }

    /* Home / other pages: the zoom toggle */
    btn.setAttribute('aria-label', 'Toggle product grid zoom');
    btn.setAttribute('aria-pressed', 'false');
    btn.textContent = '+';
    btn.addEventListener('click', function () {
      withThrottle(function () {
        var zoomed = document.body.classList.toggle('hr-zoomed');
        btn.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
        btn.textContent = zoomed ? '−' : '+';
        try { localStorage.setItem('hrZoomed', zoomed ? '1' : '0'); } catch (e) {}
      });
    });
    document.body.appendChild(btn);

    try {
      if (localStorage.getItem('hrZoomed') === '1') {
        document.body.classList.add('hr-zoomed');
        btn.setAttribute('aria-pressed', 'true');
        btn.textContent = '−';
      }
    } catch (e) {}
  }

  function setupFilters() {
    var btns = document.querySelectorAll('.hr-filter__btn');
    if (!btns.length) return;
    btns.forEach(function (btn) {
      if (btn.dataset.hrBound) return;
      btn.dataset.hrBound = '1';
      btn.addEventListener('click', function () {
        withThrottle(function () {
          var filter = btn.dataset.filter;
          btns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          document.querySelectorAll('.hr-tile').forEach(function (tile) {
            var cat = tile.dataset.category || '';
            tile.style.display = (filter === 'all' || cat === filter) ? '' : 'none';
          });
        });
      });
    });
  }

  function injectSplash() {
    if (document.querySelector('.hr-splash')) return;

    /* Suppress for 12 hours after the user dismisses */
    var TWELVE_HOURS_MS = 12 * 60 * 60 * 1000;
    try {
      var dismissedAt = parseInt(localStorage.getItem('hrSplashDismissedAt'), 10);
      if (dismissedAt && (Date.now() - dismissedAt) < TWELVE_HOURS_MS) return;
    } catch (e) {}

    var splash = document.createElement('div');
    splash.className = 'hr-splash';
    splash.setAttribute('role', 'dialog');
    splash.setAttribute('aria-label', 'Presale announcement');
    splash.innerHTML =
      '<button class="hr-splash__close" type="button" aria-label="Close">×</button>' +
      '<div class="hr-splash__title">Presale live.</div>' +
      '<div class="hr-splash__body">' +
      'Orders placed now will be shipped within 3 weeks. ' +
      '20% off any and all items during presale. Added automatically at checkout.' +
      '</div>';

    function dismiss() {
      splash.setAttribute('hidden', '');
      try { localStorage.setItem('hrSplashDismissedAt', String(Date.now())); } catch (e) {}
    }

    /* Only the X button (or Escape) dismisses — the rest of the page is navigable */
    var closeBtn = splash.querySelector('.hr-splash__close');
    if (closeBtn) closeBtn.addEventListener('click', dismiss);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dismiss();
    });

    document.body.appendChild(splash);
  }

  function fixHeaderLayout() {
    /* Belt-and-suspenders. Logo + menu both live inside .header__column--left
       (logo_position is "left" in Horizon's settings), so we stack the LEFT
       column vertically — not just the columns wrapper. */
    document.querySelectorAll('.header__columns').forEach(function (el) {
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('flex-direction', 'column', 'important');
      el.style.setProperty('align-items', 'center', 'important');
      el.style.setProperty('grid-template-columns', 'unset', 'important');
      el.style.setProperty('grid-template-areas', 'unset', 'important');
    });
    document.querySelectorAll('.header__column--left').forEach(function (el) {
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('flex-direction', 'column', 'important');
      el.style.setProperty('align-items', 'center', 'important');
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('gap', '2px', 'important');
    });
  }

  function init() {
    injectSplash();
    fixHeaderLayout();
    injectOurStory();
    renameHomeRemoveCatalog();
    injectZoomToggle();
    setupFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  [200, 600, 1500, 3000].forEach(function (delay) {
    setTimeout(function () {
      injectOurStory();
      renameHomeRemoveCatalog();
      fixHeaderLayout();
    }, delay);
  });
})();
